import { Typography } from "antd"
import React from "react"

const { Title } = Typography

const UserPrivacyAgreement: React.FC = () => {
  return (
    <article
      style={{
        background: "#fff",
        padding: "30px"
      }}>
      <Title level={2}>魔术师用户协议</Title>
      <Typography>
        <div className="section-title">一、协议总则</div>

        <div className="subsection-title">（一）协议目的与依据</div>
        <div className="content-paragraph">
          为规范魔术师（以下简称{" "}
          <span className="highlight-text">"本插件"</span>
          ）的使用与运营，保障用户（以下简称{" "}
          <span className="highlight-text">"您"</span>）与插件运营主体
          <span className="important-text">[深圳淘趣科技有限公司]</span>
          （以下简称 <span className="highlight-text">"我们"</span>
          ）的合法权益，依据《中华人民共和国民法典》《中华人民共和国电子商务法》《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》及拼多多开放平台相关规则，制定本协议。
        </div>

        <div className="contact-info">
          <strong>运营主体信息：</strong>
          <br />
          统一社会信用代码：91440300MA5F056363
          <br />
          注册地址：深圳市龙岗区坂田街道马安堂社区新河街2号金方华电商产业园2栋602-01
          <br />
          联系电话：13317956127
        </div>

        <div className="subsection-title">（二）协议效力范围</div>
        <div className="content-paragraph">
          本协议是您与我们之间关于使用本插件的核心法律文件，适用于您通过任何终端（包括电脑、手机、平板等）访问、使用本插件的全部行为。
        </div>
        <div className="content-paragraph">
          本协议同时关联《[魔术师] 隐私政策》《[魔术师]
          使用规范》及拼多多开放平台发布的《拼多多开放平台服务协议》等规则（以下统称{" "}
          <span className="highlight-text">"附属规则"</span>
          ）。附属规则是本协议的有效组成部分，与本协议具有同等法律效力。
        </div>

        <div className="subsection-title">（三）协议生效与变更</div>
        <div className="content-paragraph">
          您在首次使用本插件前，应仔细阅读并充分理解本协议全部条款（尤其是
          <span className="important-text">
            加粗标注的免责、限制责任、权利义务划分条款
          </span>
          ）。您点击 <span className="highlight-text">"同意并继续"</span>{" "}
          <span className="highlight-text">"接受"</span>{" "}
          按钮，或实际访问、使用本插件服务，即视为您已完全接受本协议及附属规则。
        </div>

        <div className="ant-divider"></div>

        <div className="section-title">二、插件服务内容</div>

        <div className="subsection-title">（一）服务定义</div>
        <div className="content-paragraph">
          本插件是基于拼多多开放平台开发的电商辅助工具，旨在为您提供{" "}
          <span className="highlight-text">
            [营销活动设置辅助、商品裂变、差评一键申诉等]
          </span>{" "}
          服务（以下统称 <span className="highlight-text">"插件服务"</span>
          ）。具体服务内容以本插件实际展示的功能模块及操作指引为准。
        </div>

        <div className="subsection-title">（二）服务范围限制</div>
        <div className="content-paragraph">
          本插件服务仅面向已通过拼多多平台实名认证的商家用户或个人消费者用户，非拼多多用户需先注册并完善拼多多账号信息，方可使用本插件。
        </div>

        <div className="ant-alert ant-alert-info">
          <strong>注意：</strong>
          本插件服务不包含拼多多平台核心功能（如直通车、订单支付、物流发货等），相关操作仍需通过拼多多官方平台完成。
        </div>

        <div className="ant-divider"></div>

        <div className="section-title">三、用户权利与义务</div>

        <div className="subsection-title">（一）用户权利</div>
        <div className="list-item">
          <strong>服务使用权利：</strong>
          在符合本协议约定及拼多多平台规则的前提下，您有权正常访问、使用本插件提供的全部已开放功能
        </div>
        <div className="list-item">
          <strong>信息查询与更正权利：</strong>
          您有权查询本人在本插件中的使用记录，若发现信息存在错误或遗漏，可向我们申请更正
        </div>
        <div className="list-item">
          <strong>投诉与建议权利：</strong>
          您对本插件服务质量、功能设计有异议或建议时，可通过官网{" "}
          <span className="highlight-text">
            https://pqmagic.cn/
          </span> 或联系电话 <span className="highlight-text">13317956127</span>{" "}
          向我们反馈
        </div>
        <div className="list-item">
          <strong>服务终止与退款权利：</strong>
          若我们未按本协议约定提供插件服务，您有权申请终止使用本插件，并根据实际情况要求退还剩余款项
        </div>

        <div className="subsection-title">（二）用户义务</div>
        <div className="list-item">
          <strong>账号合规使用义务：</strong>
          您需使用本人实名注册的拼多多账号授权登录本插件，不得使用他人账号、虚假账号或已被拼多多平台封禁的账号登录
        </div>
        <div className="list-item">
          <strong>信息真实与更新义务：</strong>
          您在使用本插件过程中提交的相关信息需真实、准确、完整
        </div>
        <div className="list-item">
          <strong>遵守平台与法律义务：</strong>
          您需严格遵守拼多多开放平台的全部规则及本插件《使用规范》，不得实施以下行为：
          <div style={{ marginTop: "8px", paddingLeft: "16px" }}>
            • 规避拼多多平台管控，如恶意刷单、虚假交易、篡改订单数据等
            <br />
            • 侵犯他人知识产权，如使用未经授权的图片、文字、商标等素材
            <br />
            • 泄露他人隐私或商业秘密
            <br />• 干扰本插件正常运营
          </div>
        </div>
        <div className="list-item">
          <strong>数据安全保护义务：</strong>
          您需妥善保管本插件相关的登录凭证及使用过程中产生的重要数据，定期备份数据并采取安全防护措施
        </div>

        <div className="ant-divider"></div>

        <div className="section-title">四、运营方权利与义务</div>

        <div className="subsection-title">（一）运营方权利</div>
        <div className="content-paragraph">
          我们有权根据技术升级、业务需求或拼多多开放平台规则变化，对本插件的功能、界面、服务流程进行优化或调整，包括但不限于新增功能模块、关闭低效功能、调整操作路径等。
        </div>

        <div className="subsection-title">（二）运营方义务</div>
        <div className="content-paragraph">
          我们将按照本协议约定，为您提供稳定、安全的插件服务，确保核心功能的正常运行。若因系统维护、服务器故障等原因需暂停服务，将提前通知您。
        </div>

        <div className="ant-divider"></div>

        <div className="section-title">五、账号与数据安全</div>

        <div className="content-paragraph">
          您的手机号是登录本插件的唯一凭证，账号所有权归您及拼多多平台所有，本插件仅提供基于该账号的服务访问通道。您需对账号的登录及使用行为负责。
        </div>

        <div className="content-paragraph">
          我们将严格遵守《个人信息保护法》及《[魔术师]
          隐私政策》，采取加密存储、访问权限控制、防火墙防护等技术措施，保护您的个人信息及商业数据安全。
        </div>

        <div className="ant-divider"></div>

        <div className="section-title">六、知识产权</div>

        <div className="content-paragraph">
          本插件的计算机软件程序、界面设计、商标、Logo、文字说明、图片素材等知识产权，均归我们或相关权利人所有，受《中华人民共和国著作权法》《中华人民共和国商标法》等法律法规保护。
        </div>

        <div className="ant-alert ant-alert-warning">
          <strong>重要提醒：</strong>
          您不得未经授权复制、修改、反编译、反向工程本插件的软件程序，或盗用本插件的界面设计、商标、Logo等。
        </div>

        <div className="ant-divider"></div>

        <div className="section-title">七、协议终止与责任承担</div>

        <div className="content-paragraph">
          协议终止情形包括用户主动申请终止、运营方终止、法定终止等情况。终止后双方需按协议约定履行相应义务。
        </div>

        <div className="content-paragraph">
          若您违反本协议约定，导致我们或第三方遭受损失，您需承担全部赔偿责任。若因我们未履行本协议义务导致您损失，我们需根据过错程度承担赔偿责任，但赔偿范围仅限于您的直接实际损失。
        </div>

        <div className="ant-divider"></div>

        <div className="section-title">八、免责说明</div>

        <div className="content-paragraph">
          <span className="important-text">感谢您选用魔术师电商插件。</span>
          本插件旨在为您提供便捷的电商主图及主图视频下载功能，助力您高效获取所需素材，提升工作效率。但需明确，由于电商平台对数据获取的规则和判定标准存在差异，使用本插件仍可能面临一些风险。
        </div>

        <div className="subsection-title">（一）插件性质说明</div>
        <div className="content-paragraph">
          魔术师电商插件是一款基于合法合规技术手段开发的工具，通过解析电商平台公开的网页数据接口，仅获取用户在正常浏览页面时可见的电商主图及主图视频，不涉及任何侵入平台数据库、破解加密数据等非法技术手段。
        </div>

        <div className="subsection-title">（二）使用风险告知</div>
        <div className="list-item">
          尽管插件合法合规，但电商平台出于自身运营和数据保护的考虑，可能会将插件的使用行为误判为非法数据抓取，不同电商平台的误判情形和处罚措施存在差异
        </div>
        <div className="list-item">
          本插件会尽力实时跟踪各电商平台规则变化，但无法保证能及时通知到每一位用户。因此，用户在使用插件过程中应定期关注电商平台规则更新
        </div>

        <div className="subsection-title">（三）用户责任与义务</div>
        <div className="list-item">
          在使用魔术师电商插件前，您务必仔细阅读并充分理解相关电商平台的服务条款和规定，确保您获取数据的用途符合平台要求及法律法规
        </div>
        <div className="list-item">
          若您发现插件使用过程中出现异常情况，如收到电商平台的警告提示、账号出现异常操作限制等，应立即停止使用本插件，并及时通知插件开发者
        </div>
        <div className="list-item">
          若因您违反电商平台规则而导致任何纠纷、损失或法律责任，均由您自行承担。您应合理、谨慎地使用本插件，避免因不当使用给自身带来不必要的风险
        </div>

        <div className="ant-divider"></div>

        <div className="section-title">九、法律适用与争议解决</div>

        <div className="content-paragraph">
          本协议的订立、履行、解释、争议解决均适用中华人民共和国法律。若发生争议，应首先通过友好协商解决；协商不成的，任何一方均有权向我们所在地有管辖权的人民法院提起诉讼。
        </div>

        <div className="content-paragraph">
          在争议解决过程中，双方应遵循相关法律法规和仲裁/诉讼程序要求，如实提供证据，积极配合处理。争议解决期间，除争议事项外，双方应继续履行本协议其他条款。
        </div>

        <div className="ant-divider"></div>

        <div className="section-title">十、其他条款</div>

        <div className="content-paragraph">
          本协议中的 <span className="highlight-text">"不可抗力"</span>{" "}
          指不能预见、不能避免且不能克服的客观情况，包括但不限于地震、洪水、台风、火灾、战争、政府禁令、网络中断等。
        </div>

        <div className="content-paragraph">
          若本协议任何条款被有管辖权的法院认定为无效或不可执行，该条款不影响其他条款的效力，其他条款仍需继续履行。
        </div>

        <div className="content-paragraph">
          使用本插件即视为您已阅读、理解并同意本免责声明的所有条款。若您不同意本声明内容，请立即停止使用魔术师电商插件。
        </div>

        <div className="content-paragraph">
          您与我们之间的通知、沟通，优先通过本插件站内信、公告或您预留的联系方式（如电话、邮箱）进行；通过上述方式发出的通知，视为已有效送达。
        </div>
        <div className="scroll-indicator">↓ 请滚动查看完整协议内容 ↓</div>
        <div className="effective-date">
          本协议自 2025年10月23日 起生效，无固定期限，直至双方按本协议约定终止
        </div>
      </Typography>
    </article>
  )
}

export default UserPrivacyAgreement
